/* Riposte — panier coulissant des fiches produit.
   Le bouton « Ajouter au panier » (et celui de la barre mobile, qui vise le
   même formulaire) ajoute sans quitter la page, puis ouvre ce panneau.
   En cas d'échec, le formulaire part normalement vers /cart : la vente passe
   avant l'effet. */
(function () {
  'use strict';

  var d = document.querySelector('[data-rpd]');
  var form = document.getElementById('rpp-form');
  if (!d || !form || !window.fetch) return;

  /* Le panneau quitte la section produit dès le chargement. Les applis
     d'avis (Trustoo, constaté le 30/09/2026) posent leur widget à la fin de
     la section qui contient le formulaire d'achat : tant que le panneau y
     était, le widget atterrissait dedans, caché, et ne se montrait qu'à
     l'ouverture du panier. Rattaché au body, il n'est plus une cible. */
  if (d.parentNode !== document.body) document.body.appendChild(d);

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var panel = d.querySelector('.rpd__panel');
  var list = d.querySelector('[data-rpd-items]');
  var total = d.querySelector('[data-rpd-total]');
  var count = d.querySelector('[data-rpd-count]');
  var foot = d.querySelector('.rpd__foot');
  var empty = d.querySelector('[data-rpd-empty]');
  var upBox = d.querySelector('[data-rpd-up]');
  var upCheck = form.querySelector('[data-rpp-up]');
  var home = document.querySelector('[data-rpp]');
  var lastFocus = null;
  var busy = false;

  /* Filet : si un élément qui n'est pas à nous arrive quand même dans le
     panneau (injecté avant ce script), il est rendu à la fiche, juste sous
     le bloc d'achat — jamais supprimé. Seules les étoiles ajoutées sous le
     nom d'un article du panier sont retirées. */
  var CONTAINERS = '.rpd, .rpd__panel, .rpd__head, .rpd__body, .rpd__foot, .rpd__item, .rpd__info, .rpd__end, .rpd__up, .rpd__up-row, .rpd__up-info';
  var anchor = home;

  function foreign(el) {
    if (el.nodeType !== 1) return false;
    if (/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return false;
    var cls = typeof el.className === 'string' ? el.className : '';
    return !/(^|\s)(rpd|rp-)/.test(cls);
  }

  function sweep() {
    d.querySelectorAll(CONTAINERS).forEach(function (box) {
      Array.prototype.slice.call(box.children).forEach(function (el) {
        if (!foreign(el)) return;
        if (box.closest('.rpd__item') || !anchor || !anchor.parentNode) {
          el.remove();
          return;
        }
        anchor.parentNode.insertBefore(el, anchor.nextSibling);
        anchor = el;
      });
    });
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      var added = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, foreign);
      });
      if (added) sweep();
    }).observe(d, { childList: true, subtree: true });
  }
  sweep();

  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  // Pastille du panier dans l'en-tête : Shopify renvoie la section à jour.
  function bubble(sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (inner) el.innerHTML = inner.innerHTML;
  }

  function post(url, body) {
    body.sections = 'cart-icon-bubble';
    body.sections_url = window.location.pathname;
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        bubble(j.sections);
        return j;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function render(cart) {
    count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;

    list.innerHTML = cart.items.map(function (it) {
      var key = esc(it.key);
      var variant = it.product_has_only_default_variant ? '' : '<p class="rpd__var">' + esc(it.variant_title) + '</p>';
      var img = it.image ? '<img class="rpd__img" src="' + esc(sized(it.image, 240)) + '" alt="" width="80" height="100" loading="lazy">' : '';
      return '<li class="rpd__item">' +
        '<a class="rpd__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="rpd__info">' +
          '<a class="rpd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="rpd__qty">' +
            '<button type="button" data-key="' + key + '" data-q="' + (it.quantity - 1) + '" aria-label="Enlever un">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-key="' + key + '" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="rpd__end">' +
          '<p class="rpd__price">' + money(it.final_line_price) + '</p>' +
          '<button type="button" class="rpd__rm" data-key="' + key + '" data-q="0">Retirer</button>' +
        '</div>' +
      '</li>';
    }).join('');

    total.textContent = money(cart.total_price);

    // Ajout proposé : seulement avec une raquette et sans le produit proposé.
    if (upBox) {
      var pid = Number(upBox.getAttribute('data-product'));
      var hasRacket = cart.items.some(function (it) { return it.product_type === 'Raquette'; });
      var hasUp = cart.items.some(function (it) { return it.product_id === pid; });
      upBox.hidden = !(hasRacket && !hasUp);
    }
  }

  function open() {
    sweep();
    if (d.classList.contains('rpd--on')) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    document.documentElement.classList.add('rpd-lock');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { d.classList.add('rpd--on'); });
    });
    panel.focus({ preventScroll: true });
  }

  function close() {
    d.classList.remove('rpd--on');
    document.documentElement.classList.remove('rpd-lock');
    setTimeout(function () { if (!d.classList.contains('rpd--on')) d.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function refreshAndOpen() {
    return getCart().then(function (c) { render(c); open(); });
  }

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('.rpp__cta').forEach(function (b) {
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    var items = [{ id: Number(form.querySelector('[data-rpp-id]').value), quantity: 1 }];
    if (upCheck && upCheck.checked) items.push({ id: Number(upCheck.value), quantity: 1 });
    post('cart/add.js', { items: items })
      .then(refreshAndOpen)
      .then(function () { if (upCheck) upCheck.checked = false; setBusy(false); })
      .catch(function () { setBusy(false); form.submit(); });
  });

  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rpd-close], [data-q], [data-rpd-up-add]');
    if (!t) return;
    if (t.hasAttribute('data-rpd-close')) { close(); return; }
    if (busy) return;
    busy = true;
    d.classList.add('rpd--busy');
    var req = t.hasAttribute('data-rpd-up-add')
      ? post('cart/add.js', { items: [{ id: Number(upBox.getAttribute('data-variant')), quantity: 1 }] })
      : post('cart/change.js', { id: t.getAttribute('data-key'), quantity: Math.max(0, Number(t.getAttribute('data-q'))) });
    req.then(getCart).then(render).catch(function () {}).then(function () {
      busy = false;
      d.classList.remove('rpd--busy');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !d.hidden) close();
  });

  // L'icône panier de l'en-tête ouvre aussi le panneau sur cette page.
  var icon = document.getElementById('cart-icon-bubble');
  if (icon) {
    icon.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      refreshAndOpen().catch(function () { window.location.href = icon.getAttribute('href') || root + 'cart'; });
    });
  }
})();
